import * as React from 'react';

import { DASHBOARD_ROUTE } from "../../../views/routes";
import startIcon from '../../../assets/icons/start.svg?url';
import { StyledNavigatorHome } from './StyledHomeRoute'

export const HomeButton: React.FC = ({ ...rest }) => {
  const icon = <img src={startIcon} alt="Hem ikon" style={{ height: '1.5625rem' }} />;

  return (
    <StyledNavigatorHome route={DASHBOARD_ROUTE} icon={icon} circular />
  )
};